module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_5000_10000.04045bde.png";